import React from "react";
import FeaturesIllustration from '../../../media/site_media/illustrations/featuresillustration.webp'
import FeaturesIllustration2 from '../../../media/site_media/illustrations/FeaturesIllustration2.webp'
import FeaturesWilliam from '../../../media/site_media/illustrations/FeaturesWilliam.webp'
import { useSearchParams } from "react-router-dom";
import { Button } from "@mui/material";
import './SalesPage.css';


export default function FeaturesBreakdown(props) {
    const [searchParams, setSearchParams] = useSearchParams();


    // Responsive sizing based on window width
    const getResponsiveSize = () => {
        if (props.windowWidth <= 380) {
            // Under 380px: extra small devices
            return {
                borderMaxWidth: '310px',
                borderHeight: '240px',
                borderMarginTop: '-25px',
                innerMinWidth: '284px',
                innerMaxWidth: '284px',
                innerHeight: '215px',
                imageMaxWidth: '340px',
                spacerHeight: '310px',
                spacerWidth: '310px'
            };
        } else if (props.windowWidth <= 400) {
            // 381-400px
            return {
                borderMaxWidth: '340px',
                borderHeight: '280px',
                borderMarginTop: '-38px',
                innerMinWidth: '305px',
                innerMaxWidth: '305px',
                innerHeight: '235px',
                imageMaxWidth: '380px',
                spacerHeight: '340px',
                spacerWidth: '340px'
            };
        } else if (props.windowWidth <= 500) {
            // 401-500px: compact phones/phablets
            return {
                borderMaxWidth: '400px',
                borderHeight: '332px',
                borderMarginTop: '-45px',
                innerMinWidth: '360px',
                innerMaxWidth: '360px',
                innerHeight: '275px',
                imageMaxWidth: '450px',
                spacerHeight: '400px',
                spacerWidth: '400px'
            };
        } else if (props.windowWidth <= 700) {
            // 501-700px: small tablets
            return {
                borderMaxWidth: '485px',
                borderHeight: '400px',
                borderMarginTop: '-55px',
                innerMinWidth: '420px',
                innerMaxWidth: '420px',
                innerHeight: '330px',
                imageMaxWidth: '540px',
                spacerHeight: '485px',
                spacerWidth: '485px'
            };
        } else if (props.windowWidth <= 900) {
            // 701-900px: tablets/small laptops
            return {
                borderMaxWidth: '560px',
                borderHeight: '464px',
                borderMarginTop: '-64px',
                innerMinWidth: '504px',
                innerMaxWidth: '504px',
                innerHeight: '400px',
                imageMaxWidth: '640px',
                spacerHeight: '560px',
                spacerWidth: '560px'
            };
        } else {
            // Above 900px: original size
            return {
                borderMaxWidth: '700px',
                borderHeight: '580px',
                borderMarginTop: '-80px',
                innerMinWidth: '630px',
                innerMaxWidth: '630px',
                innerHeight: '500px',
                imageMaxWidth: '800px',
                spacerHeight: '700px',
                spacerWidth: '700px'
            };
        }
    };

    const sizes = getResponsiveSize();

    return (
        <div id="features" style={{ padding: '50px 0px 20px', marginBottom: '120px' }}>
            <div style={{ margin: '0px auto', textAlign: 'center', marginBottom: '40px' }}>
                <p style={{ ...props.sectionHeader, margin: '16px auto 16px auto' }}>FEATURES</p>
                <p style={{ 
                    ...props.mainHeader, 
                    width: '90%', 
                    maxWidth: '900px', 
                    textAlign: 'center', 
                    margin: '0px auto 20px auto' 
                }}>
                    Everything you need in one <span style={{ 
                        fontFamily: 'GABWRWFFR', 
                        fontSize: props.windowWidth < 600 ? '26px' : '34px' 
                    }}>single</span> hub
                </p>
                <p style={{ 
                    ...props.mainDescription, 
                    width: '90%', 
                    maxWidth: '900px', 
                    textAlign: 'center', 
                    margin: '0px auto 40px auto' 
                }}>
                    Enhance your hub with our engagement and monetization tools. Every tool designed to boost interaction and revenue. Empower your users to connect and grow in meaningful ways.
                </p>
            </div>

            {/* Image with animated border */}
            <div style={{ 
                display: 'flex', 
                position: 'relative',
                justifyContent: 'center', 
                alignItems: 'center',
                margin: '60px auto 0px auto',
                padding: '20px',
                position: 'relative'
            }}>
                <div className="animated-border-container" style={{ maxWidth: sizes.borderMaxWidth, height: sizes.borderHeight, marginTop: sizes.borderMarginTop, position: 'absolute' }}>
                    <div 
                
                        style={{
                            width: '100%',
                            minWidth: sizes.innerMinWidth,
                            maxWidth: sizes.innerMaxWidth,
                            zIndex: '6',
                            height: sizes.innerHeight,
                            borderRadius: '15px',
                            display: 'block'
                        }}
                    />
                </div>

                {/* <div className="animated-border-container"> */}
                    <img 
                        src={FeaturesWilliam} 
                        alt="Features" 
                        style={{
                            width: '100%',
                            zIndex: '10',
                            position: 'absolute',
                            maxWidth: sizes.imageMaxWidth,
                            height: 'auto',
                            borderRadius: '15px',
                            display: 'block'
                        }}
                    />

                    <div style={{height: sizes.spacerHeight, width: sizes.spacerWidth}}></div>
                {/* </div> */}
            </div>

            <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '0px'}}>
            {props.logged_in === true ?
            <Button variant="contained" 
              onClick={() => window.location.assign(props.pre_influencer === true && props.influencer_bool !== true ? '/become-a-creator/start-free-trial' :  (props.pre_influencer === false && props.influencer_bool !== true ? '/become-a-creator/register' : '/' + props.current_user))}
              disableElevation
              sx={{
                padding: props.windowWidth < 450 ? '10px 12px' : '10px 20px',
                display: 'inline-block',  
                margin: '20px auto 0px auto',
                borderRadius: '10px',
                textTransform: 'none',
                backgroundColor: 'var(--brand-color)',
                '&:hover': { backgroundColor: 'var(--brand-color-hover)' }
              }}
            >
              <span className="fa fa-search" style={{ fontWeight: '600', fontSize: '16px' }}>
                {props.pre_influencer === true && props.influencer_bool === true ? 'My Hub →' : props.pre_influencer === true || props.influencer_bool === false ? 'Continue for Free →' : props.windowWidth >= 1000 ? 'My Hub →' : 'My Hub →'}
              </span>
            </Button>
            :
            <Button
              variant="contained"
              onClick={() => {
                let referralId = searchParams.get("id");
                let passiveReferralId = searchParams.get("passive_id");
                let direct_url = ''
                if (referralId != null){
                   direct_url = '/become-a-creator/register?id='+referralId
                } else if (passiveReferralId != null) {
                   direct_url = '/become-a-creator/register?passive_id='+passiveReferralId
                } else {
                   direct_url = '/become-a-creator/register'
                }
                window.location.assign(direct_url)
             }}
              disableElevation
              sx={{
                padding: props.windowWidth < 450 ? '10px 12px' : '10px 20px',
                display: 'inline-block',  
                margin: '20px auto 0px auto',
                borderRadius: '10px',
                textTransform: 'none',
                backgroundColor: 'var(--brand-color)',
                '&:hover': { backgroundColor: 'var(--brand-color-hover)' }
              }}
            >
              <span className="fa fa-search" style={{ fontWeight: '600', fontSize: '16px' }}>
                {props.windowWidth >= 1000 ? 'Start 14-Days Free →' : 'Start 14-Days Free →'}
              </span>
            </Button>
          }
          </div>
        </div>
    );
}  